// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"e2c9fd9e","453":"dfc29120","549":"0fdd3901"}[chunkId] + ".chunk.js";
};